import { Component } from '@angular/core';

import { QuestionChoiceDetailed } from 'app/student/models/question-choice-detailed';
import { BaseEnhancedReportComponent } from '../base-enhanced-report.component';

@Component({
  selector: 'kh-answer-explanation',
  styleUrls: ['./answer-explanation.component.less'],
  templateUrl: './answer-explanation.component.html',
  standalone: false
})
export class AnswerExplanationComponent extends BaseEnhancedReportComponent {
  public choice!: QuestionChoiceDetailed;
}
